let move_devices_template = `<div id="dialog-move-devices" class="modal-dialog modal-lg move-devices">
  <div class="modal-content">
    <div class="modal-header">
        Assign Devices
      <button class="btn-close" data-dismiss="modal">X</button>
    </div>
    <div class="modal-alert-container new">
      <div class="alert"></div>
    </div>
    <form>
      <div class="modal-body device-devicegroup-panel">
          <div class="row">
            <div class="col-sm-5">
              <div class="form-group">
                <label for="devices">Device IDs and/or MAC Addresses</label>
                <textarea class="form-control"
                          rows="6"
                          name="devices"
                          placeholder="Enter Device IDs, MAC addresses with colons, and/or Agent IDs. Separate entries with either a comma or space. {{{device_help_text}}}">{{device_ids}}</textarea>
              </div>
              <div class="form-group">
                <p class="help-block"><span class="fa fa-warning"></span> Attention, only Unassigned Devices may be moved between accounts.</p>
              </div>
            </div>
            <div class="col-sm-1">
              <i class="fa fa-arrow-circle-right fa-3x"
                data-toggle="tooltip"
                data-placement="bottom"
                title="Move the devices on the left to the device group on the right"
                style="color: #ccc; margin-top: 1em"></i>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="products">Account</label>
                <div class="accounts-menu"></div>
              </div>
              <div class="form-group">
                <label for="products">Product</label>
                <div class="products-menu"></div>
              </div>
              <div class="form-group">
                <label for="devicegroups">{{dg_wording}}</label>
                <div class="devicegroup-types-menu"></div>
              </div>
              <div class="form-group">
                <div class="devicegroups-menu"></div>
              </div>
              <div class="panel panel-default destination-devicegroup">
                  <div class="panel-body"></div class>
              </div>
            </div>
          </div>
      </div>
      <div class="modal-body response"></div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link cancel" data-dismiss="modal">Cancel</button>
        <button type="submit" {{#unless can_move}}disabled{{/unless}} class="btn btn-primary ">Assign Devices</button>
        <div class="loader"></div>
      </div>
    </form>
  </div>
</div>`;

export default move_devices_template;
